import React from 'react';
import { Button as AntdButton, ButtonProps as AntdButtonProps, ConfigProvider } from 'antd';
import { ButtonGroupProps as AntdButtonGroupProps } from 'antd/es/button';
import { useTheme } from '../../theme/ThemeContext';

// Define the props type for your custom Button component
export interface ButtonProps extends AntdButtonProps {}

// Define the props type for the custom Button.Group component
export interface ButtonGroupProps extends AntdButtonGroupProps {
    "data-test" ?: string;
    "data-test-id" ?: string;
}

// Wrapper component for Button
const Button: React.FC<ButtonProps> & { Group: React.FC<ButtonGroupProps> } = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdButton {...props} data-test={props['data-test']} data-test-id={props['data-test-id']} data-asper-button/>
        </ConfigProvider>
    );
};

// Wrapper component for Button.Group
const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdButton.Group {...props} data-test={props['data-test']} data-test-id={props['data-test-id']} data-asper-button-group/>
        </ConfigProvider>
    );
};

// Attach the Group component to the Button component
Button.Group = ButtonGroup;

export default Button;
